"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mirror = exports.mirrorMap = void 0;
const immer_1 = __importDefault(require("immer"));
const redux_1 = require("redux");
const store_1 = require("../../../../../../exports/store");
const actions = __importStar(require("../../../../../shared/store/action_constants"));
const action_constants_1 = require("../../../../../shared/store/action_constants");
const jot_apply_1 = require("../../../../../../modules/database/store/reducers/resource/jot_apply");
const mirrorMap = (state = {}, action) => {
    if (!action.mirrorId) {
        return state;
    }
    if (action.type === actions.RESET_MIRROR) {
        const newState = Object.assign({}, state);
        delete newState[action.mirrorId];
        return newState;
    }
    return Object.assign(Object.assign({}, state), { [action.mirrorId]: mirrorPack(state[action.mirrorId], action) });
};
exports.mirrorMap = mirrorMap;
const mirror = (state = null, action) => {
    if (action.type === store_1.ActionConstants.SET_MIRROR_DATA) {
        return action.payload;
    }
    if (!state) {
        return null;
    }
    switch (action.type) {
        case store_1.ActionConstants.UPDATE_MIRROR_INFO:
        case store_1.ActionConstants.UPDATE_MIRROR: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        case store_1.ActionConstants.UPDATE_MIRROR_NAME: {
            return Object.assign(Object.assign({}, state), { name: action.payload });
        }
        case actions.CACHE_TEMPORARY_VIEW: {
            if (!state) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { temporaryView: Object.assign(Object.assign({}, (state.temporaryView || {})), action.payload) });
        }
        case actions.CACHE_TEMPORARY_QUERY_VIEW: {
            if (!state) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { temporaryView: Object.assign(Object.assign({}, (state.temporaryView || {})), action.payload) });
        }
        case store_1.ActionConstants.MIRROR_UPDATE_REVISION: {
            return Object.assign(Object.assign({}, state), { revision: action.payload });
        }
        case store_1.ActionConstants.MIRROR_JOT_ACTION: {
            return (0, immer_1.default)(state, draft => {
                (0, jot_apply_1.JOTApply)(draft, action);
                return draft;
            });
        }
        default: {
            return state;
        }
    }
};
exports.mirror = mirror;
const MIN_WIDGET_PANEL_WIDTH = 320;
const defaultWidgetPanelStatus = {
    opening: false,
    width: MIN_WIDGET_PANEL_WIDTH,
    activePanelId: null,
    loading: false,
};
const defaultClient = {
    collaborators: [],
    widgetPanelStatus: defaultWidgetPanelStatus
};
const client = (state = defaultClient, action) => {
    switch (action.type) {
        case store_1.ActionConstants.MIRROR_ACTIVE_COLLABORATOR: {
            if (!state.collaborators) {
                return Object.assign(Object.assign({}, state), { collaborators: [action.payload] });
            }
            else if (state.collaborators.find(user => user.socketId === action.payload.socketId)) {
                console.error('warning user enter with same socketid');
                return state;
            }
            state.collaborators = [...state.collaborators, action.payload];
            return state;
        }
        case store_1.ActionConstants.MIRROR_DEACTIVATE_COLLABORATOR: {
            if (!state.collaborators) {
                return state;
            }
            state.collaborators = state.collaborators.filter(user => user.socketId !== action.payload.socketId);
            return state;
        }
        case store_1.ActionConstants.MIRROR_ROOM_INFO_SYNC: {
            return Object.assign(Object.assign({}, state), { collaborators: action.payload });
        }
        case store_1.ActionConstants.SET_MIRROR_CLIENT: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        case action_constants_1.TOGGLE_WIDGET_PANEL: {
            return Object.assign(Object.assign({}, state), { widgetPanelStatus: Object.assign(Object.assign({}, state.widgetPanelStatus), { opening: action.payload == null ? !state.widgetPanelStatus.opening : action.payload }) });
        }
        case action_constants_1.CHANGE_WIDGET_PANEL_WIDTH: {
            return Object.assign(Object.assign({}, state), { widgetPanelStatus: Object.assign(Object.assign({}, state.widgetPanelStatus), { width: Math.max(action.payload, MIN_WIDGET_PANEL_WIDTH) }) });
        }
        case action_constants_1.SWITCH_ACTIVE_PANEL: {
            return Object.assign(Object.assign({}, state), { widgetPanelStatus: Object.assign(Object.assign({}, state.widgetPanelStatus), { activePanelId: action.payload }) });
        }
        default: {
            return state;
        }
    }
};
const mirrorPack = (0, redux_1.combineReducers)({
    loading: (state = false, action) => {
        if (action.type === store_1.ActionConstants.SET_MIRROR_LOADING) {
            return action.payload;
        }
        if (action.type === store_1.ActionConstants.MIRROR_ERROR_CODE ||
            action.type === store_1.ActionConstants.SET_MIRROR_DATA) {
            return false;
        }
        return state;
    },
    connected: (state = false, action) => {
        if (action.type === store_1.ActionConstants.MIRROR_CONNECTED) {
            return true;
        }
        return state;
    },
    errorCode: (state = null, action) => {
        if (action.type === store_1.ActionConstants.MIRROR_ERROR_CODE) {
            return action.payload;
        }
        if (action.type === store_1.ActionConstants.SET_MIRROR_LOADING ||
            action.type === store_1.ActionConstants.SET_MIRROR_DATA) {
            return null;
        }
        return state;
    },
    saveStatus: (state = null, action) => {
        if (action.type === store_1.ActionConstants.MIRROR_SAVE_STATUS) {
            return action.payload;
        }
        if (action.type === store_1.ActionConstants.SET_MIRROR_LOADING ||
            action.type === store_1.ActionConstants.SET_MIRROR_DATA) {
            return null;
        }
        return state;
    },
    syncing: (state = false, action) => {
        if (action.type === store_1.ActionConstants.SET_MIRROR_SYNCING) {
            return action.payload;
        }
        return state;
    },
    mirror: exports.mirror,
    client,
});
//# sourceMappingURL=mirror.js.map